(() => {
/*
* returns string with current date and time in a sensible format
*
*/ function $e1f0b8fa1ae2171c$export$eb77681169ce8580() {
    let now = new Date();
    let month = now.toLocaleDateString('default', {
        month: 'short'
    });
    let date = now.getDate();
    let year = now.getFullYear();
    let hours = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    return `${date} ${month} ${year} ${hours}:${minutes}:${seconds}`;
}
function $e1f0b8fa1ae2171c$export$3dc27271f5d5c629(price, currencyCode = 'USD') {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return formatter.format(price / 100);
}
function $e1f0b8fa1ae2171c$var$nth(day) {
    if (day > 3 && day < 21) return `${day}th`;
    switch(day % 10){
        case 1:
            return `${day}st`;
        case 2:
            return `${day}nd`;
        case 3:
            return `${day}rd`;
        default:
            return `${day}th`;
    }
}
function $e1f0b8fa1ae2171c$export$3ae94a2503e890a1(rawDate, locale) {
    const date = new Date(rawDate);
    const year = new Intl.DateTimeFormat('en', {
        year: 'numeric'
    }).format(date);
    const month = new Intl.DateTimeFormat('en', {
        month: 'long'
    }).format(date);
    const day = new Intl.DateTimeFormat('en', {
        day: 'numeric'
    }).format(date);
    if (locale == "UK") return `${$e1f0b8fa1ae2171c$var$nth(day)} ${month} ${year}`;
    else return `${month} ${$e1f0b8fa1ae2171c$var$nth(day)} ${year}`;
}
function $e1f0b8fa1ae2171c$export$c621c6e92c748156(obj) {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value])=>{
        formData.append(key, value);
    });
    return formData;
}


async function $ee86cdb64187c77d$var$checkOrderLimit(variantData, inputQty, isVaultSubProduct) {
    const selectedVariantId = variantData.id;
    const selectedVariantOrderLimit = variantData.orderLimit;
    let cartItems = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((data)=>{
        return data.items;
    });
    let orderLimitExceeded = cartItems.some((item)=>{
        if (item.id == selectedVariantId && item.quantity + Number(inputQty) > selectedVariantOrderLimit) return true;
        // need to also check for either variant of Vault subscription in the cart
        // and prevent the other variant from being added
        if (item.title.includes('Vault Subscription') && isVaultSubProduct) return true;
    });
    return orderLimitExceeded;
}
document.addEventListener("DOMContentLoaded", async ()=>{
    const productCarousel = document.querySelector('#productCarousel');
    const carousel = new bootstrap.Carousel(productCarousel, {
        touch: true,
        ride: false
    });
    const shopCurrency = window.Shopify.currency.active;
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: shopCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const displayedPrice = document.querySelector('#displayedPrice');
    const compareAtPrice = document.querySelector('#compareAtPrice');
    const variantSelects = document.querySelectorAll('.variant-select');
    const sellingPlanFields = document.querySelectorAll(`input[name="selling_plan"]`);
    const displayedSku = document.querySelector('#displayedSku');
    const cartQtyIndicator = document.getElementById('cartQtyIndicator');
    const isVaultMember = document.getElementById('isVaultMember').value;
    // there are two versions of this select now, for small and large screens
    // on change, we need to update the displayed price and selling plan id (if one exists)
    variantSelects.forEach((select)=>{
        select.addEventListener('change', (e)=>{
            let selectedOption = select.selectedOptions[0];
            let selectedVariantPrice = selectedOption.dataset.price;
            displayedPrice.innerHTML = formatter.format(selectedVariantPrice / 100);
            let selectedCompareAt = selectedOption.dataset.compareAt;
            if (selectedCompareAt) {
                compareAtPrice.innerHTML = '<s>' + formatter.format(selectedCompareAt / 100) + '</s>';
                compareAtPrice.classList.remove('d-none');
            } else compareAtPrice.classList.add('d-none');
            let selectedVariantDetails = JSON.parse(selectedOption.dataset.detailsJson);
            let selectedVariantRenewalFreq = selectedOption.dataset.renewalFreq;
            let renewalFreqInputs = document.querySelectorAll('input[name="properties[_renewal_freq]"]');
            renewalFreqInputs.forEach((input)=>{
                input.value = selectedVariantRenewalFreq;
            });
            let selectedVariantSku = selectedOption.dataset.sku;
            // some PDPs do not display a sku (e.g. Vault)
            if (displayedSku) displayedSku.innerHTML = selectedVariantSku;
            // use boostrap carousel to() method
            // to advance slide to the one matching selected variant
            let selectedVariantId = selectedVariantDetails.id;
            let selectedVariantSlideIndex = document.querySelector(`[data-slide-variant-id="${selectedVariantId}"]`)?.dataset.slideIndex;
            if (selectedVariantSlideIndex) carousel.to(selectedVariantSlideIndex);
            // update Add to cart button based on selected variant's availability
            let selectedVariantAvailable = selectedVariantDetails.available;
            let thisForm = e.target.closest('.shopify-product-form');
            let addToCartButton = thisForm.querySelector(`[type="submit"]`);
            let atcButtonText = selectedOption.dataset.atcText;
            let bisForm = document.getElementById('backInStockForm');
            let soldOutBadge = document.getElementById('soldOutBadge');
            addToCartButton.innerHTML = atcButtonText;
            if (!selectedVariantAvailable) {
                addToCartButton.disabled = true;
                bisForm.classList.remove('d-none');
                bisForm.dataset.variantId = selectedVariantId;
                // still need to remove this class on page load
                // if the default variant is sold out...
                soldOutBadge.classList.remove('d-none');
            } else {
                addToCartButton.disabled = false;
                bisForm.classList.add('d-none');
                soldOutBadge.classList.add('d-none');
            }
            // show/hide/update order limit info callout
            let orderLimitInfos = document.querySelectorAll('.order-limit-info');
            let orderLimitQtys = document.querySelectorAll('.order-limit-qty');
            let selectedVariantOrderLimit = selectedOption.dataset?.orderLimit;
            if (selectedVariantOrderLimit) {
                orderLimitInfos.forEach((element)=>{
                    element.classList.remove('d-none');
                });
                orderLimitQtys.forEach((element)=>{
                    element.innerHTML = selectedVariantOrderLimit;
                });
            } else {
                orderLimitInfos.forEach((element)=>{
                    element.classList.add('d-none');
                });
                e.target.classList.add('mb-3');
            }
            let qtyInput = thisForm.querySelector(`[name="quantity"]`);
            // some PDPs may not have a qty input (e.g. Vault)
            if (qtyInput) qtyInput.max = selectedVariantOrderLimit;
            let lowStockAlert = document.getElementById('lowStockAlert');
            let lowStockQty = document.getElementById('lowStockQty');
            let selectedVariantQty = Number(selectedOption.dataset.inventoryQty);
            let lowStockThreshold = Number(document.getElementById('lowStockThreshold').value);
            if (selectedVariantQty > 0 && selectedVariantQty <= lowStockThreshold) {
                lowStockAlert.classList.remove('d-none');
                lowStockQty.innerHTML = selectedVariantQty;
            } else lowStockAlert.classList.add('d-none');
            if (selectedOption.dataset.sellingPlan) {
                const sellingPlanId = selectedOption.dataset.sellingPlan;
                sellingPlanFields.forEach((field)=>{
                    field.value = sellingPlanId;
                });
            }
        });
    });
    const ajaxCartModal = new bootstrap.Modal('#ajaxCartModal');
    const productForms = document.querySelectorAll('.shopify-product-form');
    productForms.forEach((form)=>{
        form.addEventListener('submit', async (e)=>{
            e.preventDefault();
            let variantSelect = e.target.querySelector('[name="id"]');
            let defaultVariant = e.target.querySelector('[id="defaultVariantData"]');
            let variantID = variantSelect.value;
            let qty = e.target.querySelector('input[name="quantity"]')?.value ?? 1;
            let sellingPlanID = e.target.querySelector('input[name="selling_plan"]')?.value;
            let propertiesInputs = Array.from(e.target.querySelectorAll('[name*="properties"]'));
            let atcButton = e.target.querySelector('[type="submit"]');
            let isVaultSubProduct = e.target.querySelector('[name="is_vault_sub_product"]').value;
            // prevent exceeding qty limit, if there is one
            let selectedVariant = variantSelect.selectedOptions ? variantSelect.selectedOptions[0] : defaultVariant;
            let orderLimitExceeded = false;
            if (selectedVariant.dataset.orderLimit) orderLimitExceeded = await $ee86cdb64187c77d$var$checkOrderLimit(selectedVariant.dataset, qty, isVaultSubProduct);
            if (orderLimitExceeded) {
                atcButton.innerHTML = 'Quantity limit reached';
                atcButton.disabled = true;
                return;
            }
            let properties = {};
            propertiesInputs?.forEach((input)=>{
                let propKey = input.name.match(/\[(.*?)\]/)[1];
                properties[propKey] = input.value;
            });
            let data = {
                'items': [
                    {
                        "id": variantID,
                        "quantity": qty,
                        "selling_plan": sellingPlanID,
                        "properties": properties
                    }
                ]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(()=>{
                return fetch(window.Shopify.routes.root + 'cart.js', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            }).then((response)=>response.json()).then((data)=>{
                const cartItems = data.items;
                $ee86cdb64187c77d$var$validateCart(cartItems, atcButton);
                cartQtyIndicator.innerHTML = data?.item_count;
                cartQtyIndicator.classList.remove('d-none');
                $ee86cdb64187c77d$var$populateAjaxCartModal(data, shopCurrency);
                ajaxCartModal.show();
            }).catch((error)=>{
                console.error('Error:', error);
            });
        });
    });
});
async function $ee86cdb64187c77d$var$populateAjaxCartModal(data) {
    const ajaxCartModalBody = document.getElementById('ajaxCartModalBody');
    const shopCurrency = data.currency;
    const items = data.items;
    let cartRows = '';
    let personalizedMessage;
    let personalizedMessageRow;
    items.forEach((item)=>{
        item.properties['Personalized message'] ? personalizedMessage = item.properties['Personalized message'] : personalizedMessage = '';
        if (personalizedMessage !== '') personalizedMessageRow = `
        <span>Personalized message: ${personalizedMessage}</span><br>
        `;
        /* let propertyRows = '';
        not doing these at all for now
      for (const prop in item.properties) {
        propertyRows += `
        <span>${prop}: ${item.properties[prop]}</span><br>
        `;
      }*/ cartRows += `
    <div class="row mb-4 text-white fw-bold">
      <div class="col-3 col-lg-3">
       <a href="${item.url}"><img src="${item.image}&width=100" class="w-100"></a>
      </div>
      <div class="col-9 col-lg-9">
        <div class="row">
          <div class="col text-start small fw-normal">${item.properties['_artist'] ?? ''}</div>
        </div>
        <div class="row">
          <div class="col text-start small">
            <a href="${item.url}" class="text-tmr-yellow text-decoration-none">${item.product_title}</a>
          </div>
        </div>
        <div class="row">
          <div class="col text-white fw-light" style="font-size:.75rem;">
            ${item?.variant_title ?? ''}<br>
            ${item?.properties['_renewal_freq'] ?? ''}<br>
            ${personalizedMessageRow ?? ''}
          </div>
          <div class="col text-end text-lowercase small"><span class="tiny">${item.quantity} x</span> ${(0, $e1f0b8fa1ae2171c$export$3dc27271f5d5c629)(item.price, shopCurrency)}</div>
        </div>
      </div>
    </div>
    `;
    });
    ajaxCartModalBody.innerHTML = cartRows;
}
async function $ee86cdb64187c77d$var$validateCart(cartItems, atcButton) {
    let hasSubscriptionLineItem = cartItems.some((item)=>{
        let props = item.properties;
        return Object.hasOwn(props, '_subscription_line_item');
    });
    const checkoutButton = document.getElementsByName("checkout")[0];
    /*
  * prevent "mixed carts" here. we can't allow a Vault subscription and other products in the
  * same cart. Necessary because Sandbag, our UK fulfillment partner, cannot process orders
  * that include a Vault sub.
  * Made it a theme setting so we can allow it in the US store
  * where it does not cause a problem - JLP, 03 Dec 2025
  */ let allowMixedCarts = document.getElementById("allowMixedCarts").value === 'true';
    if (allowMixedCarts == false) {
        let cartItemsCount = Object.keys(cartItems).length;
        if (cartItemsCount > 1 && hasSubscriptionLineItem) {
            let mixedCartAlert1 = document.getElementById("mixedCartAlert");
            checkoutButton.disabled = true;
            mixedCartAlert1.classList.remove('d-none');
        }
    }
    const removeVaultButton = document.getElementById("removeVault");
    const removeOtherButton = document.getElementById("removeOther");
    removeVaultButton.addEventListener('click', async (e)=>{
        let removed = await $ee86cdb64187c77d$var$removeItems('vault', cartItems);
        if (removed == true) {
            mixedCartAlert.classList.add('d-none');
            checkoutButton.disabled = false;
        }
    });
    removeOtherButton.addEventListener('click', async (e)=>{
        let removed = await $ee86cdb64187c77d$var$removeItems('other', cartItems);
        if (removed == true) {
            mixedCartAlert.classList.add('d-none');
            checkoutButton.disabled = false;
        }
    });
}
async function $ee86cdb64187c77d$var$removeItems(itemType, cartItems) {
    let updates = {};
    if (itemType == 'other') cartItems.forEach((item)=>{
        if (item.handle !== 'vault-subscription') updates[item.id] = 0;
    });
    else if (itemType == 'vault') cartItems.forEach((item)=>{
        if (item.handle == 'vault-subscription') updates[item.id] = 0;
    });
    const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
            updates: updates
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((data)=>{
        $ee86cdb64187c77d$var$populateAjaxCartModal(data);
        return true;
    }).catch((error)=>{
        throw new Error(error);
    });
    return response;
}

})();
//# sourceMappingURL=products.js.map
